<template>
  <el-container>
    <el-main>
      <el-row justify="space-start" :gutter="20">
        <el-col  :xs-and-down="{span: 24}" :lg="{span: 6}">
          <el-card class="box-card" style="margin-bottom:30px;">
            <h4 class="card-title">Your Rating</h4>
            <div class="card-content">
              <p>The below rating is based on an average of all ratings you've received in the last 3 months</p>
              <h1 v-if="tutors.length > 0" style="text-align:center;">{{tutors[0].rating}}%</h1>
              <el-rate
                style="text-align:center"
                v-if="tutors.length > 0"
                v-model="tutors[0].rating/10"
                disabled
                show-score
                :max="10"
                text-color="#ff9900"
                score-template="">
              </el-rate>
            </div>
          </el-card>
          <el-card class="box-card hidden-md-and-down"  >
            <h4 class="card-title">Your Invoices</h4>
            <div class="card-content">
              <router-link :to="'/tutors/invoices/'"><el-button type="primary" style="width:100%;">View invoices</el-button></router-link>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="{span: 24}" :lg="{span: 18}">
          <el-card class="box-card">
            <h4 class="card-title">Your Classrooms</h4>
            <div class="card-header">
              <!--<classroom-filter
                :filter="classrooms"
                v-model="classrooms"
                v-on:loading="loadingClassrooms = $event"
                v-on:update:classrooms="classrooms = $event"
              ></classroom-filter>-->
            </div>

              <div class="card-content">

                <el-row style="margin-top:30px; margin-bottom: 10px">

      <!--           <el-col :xs="{span: 24}" :md="{span: 6}">
                  <label class="control-label">Country:<br><small>Filter by country: </small></label><br>
                  <el-select v-model="filters[0].value" placeholder="Select Country">
                    <el-option label="All" value="ALL"></el-option>
                    <el-option label="England" value="EN"></el-option>
                    <el-option label="Wales" value="WA"></el-option>
                    <el-option label="Scotland" value="SS"></el-option>
                    <el-option label="Ireland" value="IE"></el-option>
                    <el-option label="US" value="US"></el-option>
                    <el-option label="Spain" value="ES"></el-option>
                  </el-select>
                </el-col> -->

                <!--<el-col :span="5">
                  <label class="control-label">City:</label><br>
                  <el-select v-model="filters[1].value" placeholder="select region">
                    <el-option label="All" value="ALL"></el-option>
                    <el-option label="UK" value="TEFLORG"></el-option>
                    <el-option label="US" value="TEFLUS"></el-option>
                    <el-option label="EU" value="IRELAND"></el-option>
                  </el-select>
                </el-col>-->

                <!-- <el-col :xs="{span: 24}" :md="{span: 10}">
                  <label class="control-label">Places booked <br><small>Select the comparison type and number</small></label><br>
                  <el-select v-model="filters[3].value" placeholder="Select comparison">
                    <el-option label="Equal to" value="_eq"></el-option>
                    <el-option label="Greater than or equal to" value="_gte"></el-option>
                    <el-option label="Less than or equal to" value="_lte"></el-option>
                  </el-select>
                  <el-select v-model="filters[1].value" placeholder="Select remaining spaces">
                    <el-option label="0" value="0"></el-option>
                    <el-option label="1" value="1"></el-option>
                    <el-option label="2" value="2"></el-option>
                    <el-option label="3" value="3"></el-option>
                    <el-option label="4" value="4"></el-option>
                    <el-option label="5" value="5"></el-option>
                    <el-option label="6" value="6"></el-option>
                    <el-option label="7" value="7"></el-option>
                    <el-option label="8" value="8"></el-option>
                    <el-option label="9" value="9"></el-option>
                    <el-option label="10" value="10"></el-option>
                    <el-option label="11" value="11"></el-option>
                    <el-option label="12" value="12"></el-option>
                    <el-option label="13" value="13"></el-option>
                    <el-option label="14" value="14"></el-option>
                    <el-option label="15" value="15"></el-option>
                    <el-option label="16" value="16"></el-option>
                    <el-option label="17" value="17"></el-option>
                    <el-option label="18" value="18"></el-option>
                    <el-option label="19" value="19"></el-option>
                    <el-option label="20" value="20"></el-option>
                  </el-select>
                </el-col> -->

                <el-col :xs="{span: 24}" :md="{span: 8}" >
                  <label class="control-label">Select Date Range <br><small>Uses the Start Date of the classroom</small></label><br>
                  <el-date-picker  
                    v-model="filters[2].value" 
                    type="daterange"
                    align="right" 
                    unlink-panels range-separator="-" 
                    start-placeholder="Start date" 
                    end-placeholder="End date" 
                    :picker-options="pickerOptions1">
                  </el-date-picker>
                </el-col>
                
              </el-row>
              <el-row>
              <div class="table-responsive">
                <data-tables-server 
                  class="el-table table-shopping el-table--fit el-table--scrollable-x el-table--enable-row-hover el-table--enable-row-transition" 
                  style="width: 100%" 
                  :data="classrooms" 
                  :tool-bar="false" 
                  :current-page="1" 
                  :total="total"
                  :loading="loadingClassrooms"
                  :page-size="10"
                  @query-change="getClassrooms"
                  :filters="filters"
                  :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }">

                  <el-table-column type="expand">
                    <template slot-scope="props">
                      <el-col :span="11" :offset="1">
                        <i class="el-icon-loading" v-if="loading"></i>
                        <p v-if="props.row.tutor">
                          <strong>Tutor:</strong>
                          {{props.row.tutor.firstname}} {{props.row.tutor.lastname}}
                        </p>
                        <p v-if="props.row.venue">
                          <strong>Venue:</strong>
                          {{props.row.venue.name}}, {{props.row.venue.line1}},{{props.row.venue.town}}
                          <br>
                        </p>
                        <p>
                          <strong>Attendees:</strong>
                          <br>
                          <el-tag
                            size="mini"
                            type="success"
                            v-for="(attendee,index) in props.row.attendees"
                            :key="index"
                          >{{attendee.customer.firstname}} {{attendee.customer.lastname}}</el-tag>
                        </p>
                      </el-col>
                      <el-col :span="12" v-if="props.row.isOnline">
                    
                          <strong>Sessions: </strong> 
                          <div v-for="(session,idx) in props.row.sessions" v-bind:key="idx">
                           Session{{idx+1}}: {{session | moment('dddd, MMMM Do YYYY')}}  {{props.row.startTime.substring(0,5)}} - {{props.row.endTime.substring(0,5)}} 
                          </div>
                          
                         
                          <strong>Meeting Link: </strong> <a target="_blank" :href="props.row.meetingUrl">{{props.row.meetingUrl}}</a>
                          </p>
                          <p>
                            <strong>Meeting ID: </strong> {{props.row.meetingID}}
                          </p>
                      </el-col>
                    </template>
                  </el-table-column>
                   <el-table-column label="" min-width="3">
                    <template
                      slot-scope="props"
                    >
                    <el-tooltip content="Live?" effect="light" placement="top">
                    <el-badge is-dot :type="props.row.isPublic===1?'success':'danger'"></el-badge>
                    </el-tooltip></template>
                  </el-table-column>
                  <el-table-column label="Starts" min-width="9">
                    <template
                      slot-scope="props"
                    >{{props.row.startDate | moment('DD MMM YYYY')}}</template>
                  </el-table-column>
                  <el-table-column label="Ends" min-width="9">
                    <template
                      slot-scope="props"
                    >{{props.row.endDate | moment('DD MMM YYYY')}}</template>
                  </el-table-column>
                  <el-table-column label="Days" min-width="7">
                    <template slot-scope="props">{{props.row['length']}}</template>
                  </el-table-column>
                  <el-table-column label="Attendees" min-width="10">
                    <template slot-scope="props">
                      {{props.row.numAttendees}}/{{props.row.maxAttendees}}
                    </template>
                  </el-table-column>

                  <el-table-column label="Venue" min-width="20">
                    <template slot-scope="props">{{props.row.venue.name}}</template>
                  </el-table-column>

                  <el-table-column label="Register" min-width="10">
                    <template slot-scope="props">
                      <router-link v-if="props.row.isOnline && props.row.code.substring(0,3)=='OTP'" :to="'/tutors/register-online/' +props.row.id">Register</router-link>
                    <router-link v-else :to="'/tutors/register/' +props.row.id">Register</router-link>
                    </template>
                  </el-table-column>

                  <el-table-column label="Feedback" min-width="10">
                    <template slot-scope="props">
                    <router-link :to="'/tutors/feedback/' +props.row.id">{{(props.row.feedback_aggregate.aggregate.avg.tutorRating/10)*100}}</router-link><br />

                    </template>
                  </el-table-column>

                  <el-table-column label="Invoice" min-width="12">
                    <template slot-scope="props">
                    <router-link v-if="props.row.invoiceAmount" :to="'/tutors/invoice/' +props.row.id">Edit invoice</router-link>
                    <router-link v-if="!props.row.invoiceAmount" :to="'/tutors/invoice/' +props.row.id">Raise invoice</router-link>
                    <!--<span v-if="!props.row.invoiceAmount && props.row.endDate > now" :to="'/tutors/invoice/' +props.row.id">Unavailable</span>-->
                    <span v-if="props.row.invoiceAmount && tutors.length > 0"><br>{{props.row.invoiceAmount | currentyCodeToSymbol(tutors[0].currency)}}</span>
                    </template>
                  </el-table-column>

                </data-tables-server>
                
              </div>
              </el-row>
              </div>
   
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import ClassroomFilter from "../UIComponents/ClassroomFilter.vue";
import VenueFilter from "../UIComponents/VenueFilter.vue";
import api from "./api";
import _ from "lodash";
import gql from "graphql-tag";
import moment from "moment";
export default {
  components: {
    ClassroomFilter,
    VenueFilter
  },
  data() {
    return {
      now: moment().format("YYYY-MM-DD"),
      total: 0,
      countries: [],
      classrooms: [],
      newClassroom: {},
      aggregate: {},
      total: 0,
      classroom: {
        dateCreated: moment().format(),
        dateUpdated: moment().format(),
        isPublic: "0",
        feedbackCount: "0",
        courseRatingPercentage: "0.0",
        venueRatingPercentage: "0.0",
        serviceRatingPercentage: "0.0",
        tutorRatingPercentage: "0.0",
        recommendedPercentage: "0.0",
        allRatingsPercentage: "0.0",
        historic: "0",
        invoiceSourceUrl: "",
        numberOfTens: "0",
        numAttendees: "0",
        invoiceAmount: "0",
        invoicePaid: "0",
        invoiceBonus: "0",
        additionalCost: "0",
        venueInvoicePaid: "0",
        venue: {
          id: null,
        },
        tutor: {
          id: null
        }
      },
      pickerOptions1: {
        shortcuts: [
          {
            text: "Last 24 hours",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Two Weeks",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "6 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "1 year",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      filters: [ 
        {
          value: "ALL",
          prop: "venue"
        },
        {
          value: "20",
          prop: "numAttendees",
        },
        {
          value: [
            moment().subtract(1, "months").format("YYYY-MM-DD"),
            moment().add(7, "months").format("YYYY-MM-DD")
          ],
          prop: "startDate"
        },
        {
          value: "_lte",
          prop: "numAttendees",
        },
      ],
      loadingClassrooms: false,
      selectedCountry: "",
      selectedVenue: {},
      selectedTutor: {},
      tutor: {},
      tutors: [],
      venues: [],
      classVenues: [],
      venue: {},
      loading: false,
     
      rules: {
        meta: {'classroom-code':[
          { required: true, message: "Please add code", trigger: "blur" }
        ]}
      }
    };
  },
  methods: {

    getVenues() {

      this.loadingVenues = true;

      this.$apollo
      .query({
        query: gql`
        {
          ClassRoomVenue(limit: 50) {
              id
              phone
              country
              line1
              line2
              town
              region
              postcode
              name
              website
              email
              contactName
              dateCreated
              dateUpdated
              lat
              long
              historic
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.classVenues = response.data.ClassRoomVenue;
        this.loadingVenues = false;
        //this.venueTotal = response.data.countUnlimited;
      });
    },

    setVenue(v) {
      this.selectedVenue = this.classVenues.find(x => x.id == v);
    },

    setEndDate(length) {
      this.classroom.endDate = moment(this.classroom.startDate).add(length-1, "days");
    },

    getCountries() {
      api.getCountries().then(response => {
        this.countries = response.data.data;
      });
    },

    getClassrooms(queryInfo) {

      var id = this.id

      if ( queryInfo != undefined ) {

        var type = queryInfo.type;
        var page = queryInfo.page;
        var pageSize = queryInfo.pageSize;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'startDate';

        (queryInfo.type === 'page' || queryInfo.type === 'size' || queryInfo.type === 'sort') //&&
        //this.$message(`page: ${queryInfo.page}, pageSize: ${queryInfo.pageSize}, prop: ${queryInfo.sort.prop}, order: ${queryInfo.sort.order}`)

        
        if (queryInfo.sort.order === 'ascending') {
          orderDir = 'asc_nulls_last';
        } else if (queryInfo.sort.order === 'descending') {
          orderDir = 'desc_nulls_last';
        } else {}
        if (queryInfo.sort.prop != undefined) {
          orderProp = queryInfo.sort.prop;
        }

      } else {

        var type = 'init';
        var page = 1;
        var pageSize = 10;
        var orderDir = 'asc_nulls_last';
        var orderProp = 'startDate';

      }

      this.loadingClassrooms = true;
      var startDate = moment(this.filters[2].value[0]).format("YYYY-MM-DD");
      var endDate = moment(this.filters[2].value[1]).format("YYYY-MM-DD");

      var equal = this.filters[3].value
      var equalStatus = this.filters[0].value === "ALL" ? "_neq" : "_eq"

      this.$apollo
      .query({
        // desc_nulls_last filters out any null data
        query: gql`
          {
            ClassRoom(
              limit: ${pageSize}, 
              offset: ${(page - 1) * pageSize},
              order_by: {${orderProp}:${orderDir}},
              where: { 
                  _and: [
                    {venue: {country: {${equalStatus}: "${this.filters[0].value}"}}},
                    { numAttendees: {${equal}: "${this.filters[1].value}"} },
                    { startDate: {_gte: "${startDate}"} },
                    { startDate: {_lte: "${endDate}"} },
                    { tutorId: {_eq: "${id}"} }
                  ]
                }
            ) {
              id
              code
              isPublic
              length
              maxAttendees
              numAttendees
              venueId
              tutorId
              startDate
              endDate
              isOnline
              sessions
              startTime
              endTime
              meetingUrl
              meetingID
              invoiceAmount
              invoiceBonus
              invoiceDate
              invoicePaid
              invoicePaidDate
              numberOfTens
              recommendedPercentage
              serviceRatingPercentage
              tutorRatingPercentage
              tutorId
              feedbackCount
              tutor {
                id
                firstname
                lastname
                email
              }
              venue {
                id
                town
                region
                country
                name
                line1
              }
              attendees {
                customer {
                  id
                  firstname
                  lastname
                }
              }
               feedback_aggregate {
      aggregate {
        avg {
          tutorRating
        }
      }
    }
            }
            
            ClassRoom_aggregate(
              where: { 
                 _and: [
                    {venue: {country: {${equalStatus}: "${this.filters[0].value}"}}},
                    { numAttendees: {${equal}: "${this.filters[1].value}"} },
                    { startDate: {_gte: "${startDate}"} },
                    { startDate: {_lte: "${endDate}"} },
                    { tutorId: {_eq: "${id}"} }
                  ]
                }
            ) {
              aggregate {
                count
              }
            }
          }
        `,
        // can get error if needed
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.classrooms = response.data.ClassRoom;
        this.aggregate = response.data.ClassRoom_aggregate.aggregate;
        this.total = response.data.ClassRoom_aggregate.aggregate.count;
        this.loadingClassrooms = false;
      });
    },

    getTutors() {

      var id = this.id
      this.loadingTutors = true;

      this.$apollo
      .query({
        query: gql`
        {
          Tutor(
            limit: 50,
            where: {id: {_eq: ${id}}}
          ) {
            id
            firstname
            lastname
            currency
            email
            rating
            isActive
            canLogin
            address {
              id
              line1
              line2
              country
              town
              phone
            }
          
          }
        }`,
        error(error) {
          this.error = JSON.stringify(error);
        }
      })
      .then(response => {
        this.tutors = response.data.Tutor;
        this.loadingTutors = false;
      });
    },

    setTutor(t) {
      this.selectedTutor = this.tutors.find(x => x.id == t);
    },


     async getTutorVenue(row, expanded) {
      //don't bother if closing the row or we already got the data
      if (expanded.length && !row.venue) {
        this.loading = true;
        //only call getTutor if classroom as a tutor-id else resolve to 'No Tutor Assigned'
        const getTutor = row.tutor.id
          ? api.getTutor(row.tutor.id)
          : new Promise((resolve, reject) =>
              resolve({ data: { data: "No Tutor Assigned" } })
            );
        const getVenue = api.getVenue(row.meta["venue-id"]);
        const getAttendees = api.getOrdersByClassroomId(row.id);
        // Call both functions with promise.all
        await Promise.all([getTutor, getVenue,getAttendees]).then(response => {
          row.meta.tutor = response[0].data.data;
          row.meta.venue = response[1].data.data;
          row.meta.attendees= response[2].data
          this.loading = false;
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  },
  mounted() {
    this.getTutors();
    this.getVenues();
    this.getClassrooms();
  },
  computed: {
    id(){
      const token = localStorage.getItem('vuex')
      const parsed = JSON.parse(token)
      const id = parsed['auth']['id']
      console.log('id: ', id);
      return id
    }
  }
};
</script>
<style>

.el-range-editor.el-input__inner {
    width:100% !important;
    max-width:350px;
}
.el-date-range-picker table {
    min-width: 285px;
}
sup{top:-.1em}
</style>


// WEBPACK FOOTER //
// src/components/Tutor/Classes.vue